var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 3.66667L13.9833 12.0208C13.8517 14.155 13.7858 15.2225 13.25 15.99C12.9855 16.3693 12.6449 16.6894 12.25 16.93C11.4525 17.4167 10.3833 17.4167 8.245 17.4167C6.10333 17.4167 5.0325 17.4167 4.23333 16.9292C3.83824 16.6881 3.49768 16.3674 3.23333 15.9875C2.69833 15.2192 2.63333 14.15 2.505 12.0125L2 3.66667M0.75 3.66667H15.75M11.63 3.66667L11.0608 2.49333C10.6833 1.71333 10.4942 1.32417 10.1683 1.08083C10.096 1.02693 10.0193 0.978994 9.93917 0.9375C9.57833 0.75 9.145 0.75 8.27917 0.75C7.39083 0.75 6.94667 0.75 6.57917 0.945C6.49793 0.988509 6.42044 1.03868 6.3475 1.095C6.01833 1.3475 5.83417 1.75167 5.46583 2.55917L4.96083 3.66667",
    stroke: "#172A47",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteBlack);
export default __webpack_public_path__ + "static/media/delete_black.45418dca4267ec9c8987b5bb4961f516.svg";
export { ForwardRef as ReactComponent };